import { api, ApiRequestConfig } from 'api';
import { HttpErrorResponse, ThunkConfig } from 'types/common';
import { FetchStoresProps, StoresList } from '../types';

export type GetStoresConfig = {
  host: string;
  params?: FetchStoresProps;
  config?: ApiRequestConfig;
};

export const getStores = async (
  { host, params, config }: GetStoresConfig,
  { rejectWithValue }: ThunkConfig,
) => {
  try {
    return await api.get<StoresList>(`${host}/get-stores`, params, config);
  } catch (error) {
    const err = error as HttpErrorResponse;
    return rejectWithValue(err?.code || err?.status);
  }
};
